export class DocumentCreationFailedError extends Error {
	constructor(private readonly id: string, private readonly collection: string) {
		super();
		this.message = `Can't create document ${this.id} for collection ${this.collection}. Schema invalid`;
	}
}
